import * as React from "react";
const SvgFiRrTrashCanCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16.273 11.814a1 1 0 0 1-.043 1.414l-3.046 2.867a2.96 2.96 0 0 1-2.084.844 3 3 0 0 1-2.104-.852L7.81 15.046a1 1 0 0 1 1.32-1.502l1.225 1.077c.427.414 1.057.415 1.44.033l3.062-2.884a1 1 0 0 1 1.414.043zM22 5a1 1 0 0 1-1 1h-1v13c0 2.757-2.243 5-5 5H9c-2.757 0-5-2.243-5-5V6H3a1 1 0 1 1 0-2h3.101A5.01 5.01 0 0 1 11 0h2a5.01 5.01 0 0 1 4.899 4H21a1 1 0 0 1 1 1M8.172 4h7.656A3 3 0 0 0 13 2h-2a3 3 0 0 0-2.828 2M18 6H6v13c0 1.654 1.346 3 3 3h6c1.654 0 3-1.346 3-3z"
    />
  </svg>
);
export default SvgFiRrTrashCanCheck;
